__turbopack_context__.v({
  "desktopWrapper": "QxiYaq_desktopWrapper",
  "featuresNavigationMenu": "QxiYaq_featuresNavigationMenu",
  "h5": "QxiYaq_h5",
  "logo__nvvZx": "QxiYaq_logo__nvvZx",
  "logo__ubRz": "QxiYaq_logo__ubRz",
  "logo__ytBc0": "QxiYaq_logo__ytBc0",
  "mobileWrapper": "QxiYaq_mobileWrapper",
  "root": "QxiYaq_root",
});
